import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './lib/i18n';
import { Home } from './pages/Home';
import { Toaster } from 'sonner';
import { initGoogleAds } from './lib/gtag';
export function App() {
  useEffect(() => {
    initGoogleAds();
  }, []);
  return <I18nProvider data-id="element-0" data-mp="3fbjcp7zok1xj">
      <BrowserRouter data-id="element-1" data-mp="3fb19frelong4">
        <div className="min-h-screen bg-[#FAFAFA] text-[#0A0A0F] font-sans selection:bg-violet-200 selection:text-violet-900 relative" data-id="element-2" data-mp="3f8ndzhg0d981">
          <div className="bg-grain" data-id="element-3" data-mp="2mmlt91jqfz37" />
          <Routes data-id="element-4" data-mp="2mndna7xolord">
            <Route path="/" element={<Home data-id="element-6" data-mp="31agoopp4khjz" />} data-id="element-5" data-mp="2mjzmh44o1nm1" />
          </Routes>
          <Toaster theme="light" position="bottom-right" toastOptions={{
          style: {
            background: '#FFFFFF',
            border: '1px solid #E5E5EA',
            color: '#0A0A0F'
          }
        }} data-id="element-7" data-mp="31bi7xhgaoacs" />
        </div>
      </BrowserRouter>
    </I18nProvider>;
}